@use "variables" as *;

.skeletonWrapper {
  width: 460px;
  display: flex;
  column-gap: 18px;

  > span:nth-child(1) {
    width: 275px;
  }

  > span:nth-child(2) {
    width: 167px;
  }
}
